import {
  applySnapshot,
  getSnapshot,
  Instance,
  SnapshotIn,
  types,
} from 'mobx-state-tree';
import { LoadingState, LoadingStates } from 'globals/types';
import { temporaryEndpoints } from 'http/endpoints';
import { isStoreInitialized, performSetAction } from 'models/utils/utils';
import { DetailsGroup, DetailsGroupProps } from './details/details';

export interface UpgradeDetailsProps {
  data: DetailsGroupProps;
  status: LoadingState;
}

export const UpgradeDetails = types
  .model({
    data: types.optional(DetailsGroup, {}),
    status: types.optional(
      types.enumeration(LoadingStates),
      LoadingState.INITIAL
    ),
  })
  .actions((self) => ({
    set(props: UpgradeDetailsProps): void {
      applySnapshot(self, {
        ...getSnapshot(self),
        ...props,
      });
    },
    updateStatus(status: LoadingState): void {
      applySnapshot(self, {
        ...getSnapshot(self),
        status,
      });
    },
  }))
  .actions((self) => ({
    async setStore(): Promise<void> {
      await performSetAction({
        store: self,
        endpoint: temporaryEndpoints.upgrade.details,
      });
    },
  }))
  .actions((self) => ({
    async init(): Promise<void> {
      const { status } = getSnapshot(self);
      if (isStoreInitialized(status)) return;
      await self.setStore();
    },
    async update(): Promise<void> {
      await self.setStore();
    },
  }))
  .views((self) => ({
    getDetails(): DetailsGroupProps {
      const { data } = self;
      return getSnapshot(data);
    },
  }));

export const upgradeDetails = UpgradeDetails.create();
export type UpgradeDetailsSnapshot = SnapshotIn<typeof UpgradeDetails>;
export type UpgradeDetailsInstance = Instance<typeof UpgradeDetails>;
export default upgradeDetails;
